<template>
  <div>
    <unicom-linha :espacamento="false" style="min-height: 35px">
      <unicom-coluna sm="auto" alinhamento="center" class="mr-3">
        <unicom-icone style="color: #dee2e6" nome="pie-chart" :tamanho="25" />
      </unicom-coluna>
      <unicom-coluna sm="auto" alinhamento="center">
        <div
          style="color: #dee2e6; font-size: 21px"
          class="negrito fonte-primaria"
        >
          Tipos de prestadores
        </div>
      </unicom-coluna>
    </unicom-linha>
    <content-loader
      width="1336"
      height="400"
      viewBox="0 0 1336 400"
      primaryColor="#DEE2E6"
      secondaryColor="#f6f6f6"
      :speed="1"
    >
      <path
        id="Vetor importado"
        fill="none"
        stroke="black"
        stroke-width="1"
        d="M 321.50,339.50
            C 321.50,339.50 172.50,339.50 172.50,339.50
              172.50,339.50 172.50,355.50 172.50,355.50
              172.50,355.50 321.50,355.50 321.50,355.50
              321.50,355.50 321.50,339.50 321.50,339.50 Z
            M 456.50,307.50
            C 456.50,307.50 172.50,307.50 172.50,307.50
              172.50,307.50 172.50,323.50 172.50,323.50
              172.50,323.50 456.50,323.50 456.50,323.50
              456.50,323.50 456.50,307.50 456.50,307.50 Z
            M 508.50,274.50
            C 508.50,274.50 172.50,274.50 172.50,274.50
              172.50,274.50 172.50,290.50 172.50,290.50
              172.50,290.50 508.50,290.50 508.50,290.50
              508.50,290.50 508.50,274.50 508.50,274.50 Z
            M 578.50,242.50
            C 578.50,242.50 172.50,242.50 172.50,242.50
              172.50,242.50 172.50,258.50 172.50,258.50
              172.50,258.50 578.50,258.50 578.50,258.50
              578.50,258.50 578.50,242.50 578.50,242.50 Z
            M 653.50,210.50
            C 653.50,210.50 172.50,210.50 172.50,210.50
              172.50,210.50 172.50,226.50 172.50,226.50
              172.50,226.50 653.50,226.50 653.50,226.50
              653.50,226.50 653.50,210.50 653.50,210.50 Z
            M 722.50,178.50
            C 722.50,178.50 172.50,178.50 172.50,178.50
              172.50,178.50 172.50,194.50 172.50,194.50
              172.50,194.50 722.50,194.50 722.50,194.50
              722.50,194.50 722.50,178.50 722.50,178.50 Z
            M 750.50,146.50
            C 750.50,146.50 172.50,146.50 172.50,146.50
              172.50,146.50 172.50,162.50 172.50,162.50
              172.50,162.50 750.50,162.50 750.50,162.50
              750.50,162.50 750.50,146.50 750.50,146.50 Z
            M 845.50,114.50
            C 845.50,114.50 172.50,114.50 172.50,114.50
              172.50,114.50 172.50,130.50 172.50,130.50
              172.50,130.50 845.50,130.50 845.50,130.50
              845.50,130.50 845.50,114.50 845.50,114.50 Z
            M 971.50,82.50
            C 971.50,82.50 172.50,82.50 172.50,82.50
              172.50,82.50 172.50,98.50 172.50,98.50
              172.50,98.50 971.50,98.50 971.50,98.50
              971.50,98.50 971.50,82.50 971.50,82.50 Z
            M 1043.50,50.50
            C 1043.50,50.50 172.50,50.50 172.50,50.50
              172.50,50.50 172.50,66.50 172.50,66.50
              172.50,66.50 1043.50,66.50 1043.50,66.50
              1043.50,66.50 1043.50,50.50 1043.50,50.50 Z
            M 1233.50,18.50
            C 1233.50,18.50 172.50,18.50 172.50,18.50
              172.50,18.50 172.50,34.50 172.50,34.50
              172.50,34.50 1233.50,34.50 1233.50,34.50
              1233.50,34.50 1233.50,18.50 1233.50,18.50 Z"
      />
    </content-loader>
  </div>
</template>

<script>
import { ContentLoader } from "vue-content-loader";

export default {
  components: {
    ContentLoader
  }
};
</script>

<style lang="scss" scoped>
.carregando-tipo-prestador {
  position: absolute;
  left: 31px;
  top: 16px;
}
</style>
